import {Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {ISystemParameter} from "../../../pages/management/system-parameter-management/models/system-parameter";
import {GroupByPipe} from "../../pipes/group-by.pipe";
import {ISystemParameterItem} from "../../../pages/management/system-parameter-management/models/system-parameter-item";
import {Observable, tap} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  constructor(private readonly apiService: ApiService) {
  
  }

  getValues(groupKey: string, parameterKey: string): Observable<ISystemParameter> {
    return this.apiService.get<ISystemParameter>(`parameter/${groupKey}/${parameterKey}`)
      .pipe(tap((response: ISystemParameter) => {
        return new GroupByPipe().transform(response.parameterData.filter((item: ISystemParameterItem) => !item.isDeleted), 'key')
      }));
  }

  getParameterValues(groupKey: string, parameterKey: string): Observable<ISystemParameter> {
    return this.apiService.get<ISystemParameter>(`parameter/${groupKey}/${parameterKey}`)
      .pipe(tap((response: ISystemParameter) => {
        return response;
      }));
  }

  getParameterValueByKeyname(keyname: string) {
    return this.apiService.get<{ value: any }>(`parameter/getParameterValueByKeyname/${keyname}`);
  }

  updateParameterValueByKeyname(keyname:string,value:any,type:'string'|'array'){
    return this.apiService.patch<{ value: any }>(`parameter/updateParameterValueByKeyname`,{
      keyname,
      value,
      type
    });

  }
}
